const getExtname = (name: string) => name.split('.').pop() || name;

export default getExtname;
